export default "__VITE_ASSET__Btu40Y1p__"